'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showReferAFriendBanner = exports.SHOW_REFER_A_FRIEND_BANNER = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doShowReferAFriendBanner = doShowReferAFriendBanner;
exports.watchReferAFriendBanner = watchReferAFriendBanner;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _selectors = require('redux/saga/selectors');

var _bound = require('redux/saga/entities/bound');

var _memberStatus = require('enums/memberStatus');

var _BannerHost = require('features/Banners/BannerHost');

var _ReferAFriendBanner = require('components/Banner/ReferAFriendBanner');

var _FriendbuyWidget = require('components/Friendbuy/FriendbuyWidget');

var _Banners = require('features/Banners/Banners.reducer');

var _timeAndDate = require('constants/time-and-date');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doShowReferAFriendBanner),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchReferAFriendBanner);

var REFER_A_FRIEND_EXPIRATION_DAYS = 5;

var SHOW_REFER_A_FRIEND_BANNER = exports.SHOW_REFER_A_FRIEND_BANNER = 'SHOW_REFER_A_FRIEND_BANNER';
var showReferAFriendBanner = exports.showReferAFriendBanner = function showReferAFriendBanner(banner) {
  return { type: SHOW_REFER_A_FRIEND_BANNER, banner: banner };
};

function doShowReferAFriendBanner(client) {
  var user, isActiveUser, _ref, rafSenderReward;

  return _regenerator2.default.wrap(function doShowReferAFriendBanner$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(__SERVER__ && !__TEST__)) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return');

        case 2:
          _context.next = 4;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 4:
          if (_context.sent) {
            _context.next = 6;
            break;
          }

          return _context.abrupt('return');

        case 6:
          _context.next = 8;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 8:
          user = _context.sent;
          isActiveUser = (0, _memberStatus.memberStatus)('ACTIVE', user && user.membership.status);
          _context.next = 12;
          return (0, _effects.call)(_FriendbuyWidget.extractRafRewards, user);

        case 12:
          _ref = _context.sent;
          rafSenderReward = _ref.rafSenderReward;

          if (!(isActiveUser && rafSenderReward)) {
            _context.next = 19;
            break;
          }

          _context.next = 17;
          return (0, _effects.call)(_BannerHost.registerBanner, 'RAFBanner', _ReferAFriendBanner.ReferAFriendBanner);

        case 17:
          _context.next = 19;
          return (0, _effects.put)((0, _Banners.addAnnouncement)('RAFBanner', 'RAFBanner', {
            rafSenderReward: rafSenderReward
          }, {
            suppressible: _timeAndDate.DAY_MS * REFER_A_FRIEND_EXPIRATION_DAYS
          }));

        case 19:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchReferAFriendBanner(client) {
  return _regenerator2.default.wrap(function watchReferAFriendBanner$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, SHOW_REFER_A_FRIEND_BANNER, doShowReferAFriendBanner, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}